// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3PxA1","resendInfoText":"OnGoingPaymentBox_resendInfoText__2grY1"};